import { Toaster } from "@/components/ui/toaster";
import Pages from "@/pages/index.jsx";
import { AuthProvider } from '@descope/react-sdk';
import './App.css';

function App() {
  return (
    <AuthProvider projectId="P2kGuLlflRjxjZKpQNVAm6MznSz2" baseUrl="https://auth.stage.getefficio.ai">
      <Pages />
      <Toaster />
    </AuthProvider>
  )
}

export default App 
